import React from 'react';
import PropTypes from 'prop-types';
import { getTranslation, withLang, langType } from '../../i18n';
import { localizedType } from '../../constants/types';

/* WARNING: UH-670 - if the value passed in here as html is just basic text, it won't be accessible */
const TranslatedHTMLText = ({
  inLanguage, html, lang, className
}) => (
  <div
    className={`${className} rich-text`}
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{
      __html: getTranslation(html,
        inLanguage || lang)
    }}
  />
);

const { string } = PropTypes;
TranslatedHTMLText.propTypes = {
  className: string,
  inLanguage: string,
  html: localizedType.isRequired,
  ...langType
};
TranslatedHTMLText.defaultProps = {
  className: '',
  inLanguage: null
};

export default withLang(TranslatedHTMLText);
